import React, { useRef, useEffect } from 'react';
import './Gloves.scss';
import videomov from '../../../../assets/artemis/gloves/artemis_gloves.mov';
import video from '../../../../assets/artemis/gloves/artemis_gloves.webm';
import poster from '../../../../assets/artemis/gloves/artemis_gloves_poster.png';

function ArtemisGloves() {
  const videoRef = useRef();
  const glovesRef = useRef();
  useEffect(() => {
    const videoCurrent = videoRef.current;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.7) {
              videoCurrent.play();
            }
          }
        });
      },
      { threshold: [0, 0.7] }
    );
    observer.observe(videoCurrent);
  }, []);

  return (
    <section className="gloves gloves-artemis" ref={glovesRef}>
      <div className="gloves__text gloves__text-artemis">
        <h3 className="gloves__text__title gloves__text__title-artemis">Improved Glove Design</h3>
        <p className="gloves__text__copy">
          NASA’s next gloves will be an improvement upon current versions and better accommodate
          smaller hands.
        </p>
      </div>
      <div className="gloves__animation gloves__animation-artemis">
        <video
          muted
          playsInline
          preload="auto"
          ref={videoRef}
          className="gloves__animation__video"
          poster={poster}
        >
          <source src={videomov} type="video/quicktime" />
          <source src={video} type="video/webm" />
        </video>
      </div>
    </section>
  );
}

export default ArtemisGloves;
